import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import ar from './ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

const normalizeLanguage = (lng) =>
  String(lng || 'en').toLowerCase().startsWith('ar') ? 'ar' : 'en';

const getLanguageDirection = (lng) =>
  normalizeLanguage(lng) === 'ar' ? 'rtl' : 'ltr';

const syncDocumentLanguage = (lng) => {
  if (typeof document === 'undefined') {
    return;
  }

  const language = normalizeLanguage(lng || i18n.resolvedLanguage || i18n.language);
  const dir = getLanguageDirection(language);

  document.documentElement.setAttribute('lang', language);
  document.documentElement.setAttribute('dir', dir);

  if (document.body) {
    document.body.setAttribute('dir', dir);
  }
};

i18n.on('initialized', () => {
  syncDocumentLanguage();
});

i18n.on('languageChanged', (lng) => {
  syncDocumentLanguage(lng);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeLanguage,
    },
  });

syncDocumentLanguage();

export default i18n;
